var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.getDemandList,
          expression: "getDemandList",
        },
      ],
      ref: "demandApplyPage",
      staticClass: "container-fluid infinite-list",
      staticStyle: { position: "relative" },
      attrs: {
        "infinite-scroll-disabled": "disabled",
        "infinite-scroll-immediate": "false",
      },
      on: { scroll: _vm.scroll },
    },
    [
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("申請日期")]),
                  _c("el-date-picker", {
                    staticClass: "w-100",
                    attrs: {
                      type: "daterange",
                      clearable: false,
                      "range-separator": "~",
                      "start-placeholder": "yyyy-MM-dd",
                      "end-placeholder": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.applyDateRange,
                      callback: function ($$v) {
                        _vm.applyDateRange = $$v
                      },
                      expression: "applyDateRange",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺單號")]),
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "50",
                      placeholder: "請輸入關鍵字",
                    },
                    model: {
                      value: _vm.searchCondition.manpowerDemandNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "manpowerDemandNo", $$v)
                      },
                      expression: "searchCondition.manpowerDemandNo",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺名稱")]),
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "50",
                      placeholder: "請輸入關鍵字",
                    },
                    model: {
                      value: _vm.searchCondition.manpowerDemandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "manpowerDemandName", $$v)
                      },
                      expression: "searchCondition.manpowerDemandName",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.positionCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "positionCode", $$v)
                        },
                        expression: "searchCondition.positionCode",
                      },
                    },
                    _vm._l(_vm.positionList, function (position) {
                      return _c("el-option", {
                        key: position.PositionCode,
                        attrs: {
                          label: position.PositionName,
                          value: position.PositionCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺狀態")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { clearable: "", placeholder: "請選擇" },
                      model: {
                        value: _vm.searchCondition.manpowerDemandStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchCondition,
                            "manpowerDemandStatus",
                            $$v
                          )
                        },
                        expression: "searchCondition.manpowerDemandStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (status) {
                      return _c("el-option", {
                        key: status.Key,
                        attrs: { label: status.Value, value: status.Key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-search",
                  staticStyle: { "margin-top": "30px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      ;(_vm.pageNumber = 1),
                        (_vm.demandList = []),
                        (_vm.showDemandList = []),
                        (_vm.totalDemand = 0),
                        _vm.getDemandList()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-search",
                  staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                  attrs: { type: "button" },
                  on: { click: _vm.createDemand },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.searchCondition = {}
                      _vm.applyDateRange = [
                        new Date(_vm.$common.getThreeMonthsAgo()),
                        new Date(_vm.$common.getToday()),
                      ]
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.demandList.length > 0
        ? _c("div", { staticClass: "tool-list" }, [
            _c("div", { staticClass: "tool-list-about-card" }, [
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "block" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "block"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "grid-outline" },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "list" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "list"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "list-outline" },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "demand-card-list",
          class: {
            "list-style": _vm.gridStyle === "list",
            "block-style": _vm.gridStyle === "block",
          },
        },
        _vm._l(_vm.demandList, function (demand, index) {
          return _c(
            "div",
            {
              key: demand.Guid + index,
              staticClass: "demand-card infinite-list-item",
            },
            [
              _c("DemandCard", {
                ref: "demandCard",
                refInFor: true,
                attrs: { category: "apply", data: demand, showCheckbox: true },
                on: { updateSelectDemand: _vm.updateSelectDemand },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "apply",
                      fn: function ({ props }) {
                        return [
                          props.ManpowerDemandStatus === "New"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editDemand(props.Guid)
                                    },
                                  },
                                },
                                [_vm._v(" 編輯 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          cardType: "demandCard",
          cardStatus: _vm.cardStatus,
          selectedCardList: _vm.chooseDemandList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function ({ props }) {
              return [
                props === null || props === "New"
                  ? _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.batchApproval()
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: { name: "person-outline", fill: "#FFF" },
                        }),
                        _c("span", [_vm._v("送出")]),
                      ],
                      1
                    )
                  : _vm._e(),
                props === null || props === "New" || props === "Pending"
                  ? _c(
                      "button",
                      {
                        staticClass: "action-btn",
                        staticStyle: { "background-color": "red" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openActionModal()
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: { name: "trash-outline", fill: "#FFF" },
                        }),
                        _c("span", [_vm._v("作廢")]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("DemandDetailModal"),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "deleteModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "deleteValid",
                  staticClass: "modal-content",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit, reset }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return handleSubmit(_vm.deleteDemand)
                                },
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", [_vm._v("作廢")]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm._v("確認作廢 ?"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.deleteReason,
                                                      expression:
                                                        "deleteReason",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    cols: "50",
                                                    rows: "5",
                                                    maxlength: "200",
                                                    placeholder:
                                                      "請輸入原因(必填)",
                                                  },
                                                  domProps: {
                                                    value: _vm.deleteReason,
                                                  },
                                                  on: {
                                                    compositionstart: function (
                                                      $event
                                                    ) {
                                                      _vm.is_composing = true
                                                    },
                                                    compositionend: function (
                                                      $event
                                                    ) {
                                                      _vm.is_composing = false
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.deleteReason =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                errors[0] && !_vm.is_composing
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Cancel")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    attrs: { type: "submit" },
                                  },
                                  [_vm._v("作廢")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }